import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Observable, of} from 'rxjs';
import {shareReplay} from 'rxjs/operators';
import {DayInformation} from '../shared/models/day-information.model';
import {Occasion} from '../shared/models/occasion.model';
import {Task} from '../shared/models/task.model';
import {ServerConfigService} from './server-config.service';

const URL_ALL_TASKS = 'getAllTasks';
const URL_DAY_TASKS = 'getTasksForDay';
const URL_TASK_OCCASIONS = 'getOccasions';

@Injectable({
    providedIn: 'root'
})
export class DayInformationService {


    private tasks: Observable<Task[]> = of([]);

    constructor(
        private http: HttpClient,
        private translate: TranslateService,
        private config: ServerConfigService
    ) {
        this.initTasks();
    }

    initTasks() {
        const requestUrl = `${this.config.getRestUrl()}/${URL_ALL_TASKS}/${this.translate.getCurrentLang()}`;

        this.tasks = this.http.get<Array<Task>>(requestUrl)
            .pipe(
                shareReplay()
            );
    }

    getDayInformation(date: number): Observable<DayInformation> {
        const requestUrl = `${this.config.getRestUrl()}/${URL_DAY_TASKS}/${date}/${this.translate.getCurrentLang()}`;
        return this.http.get<DayInformation>(requestUrl);
    }

    getAllTasks(): Observable<Array<Task>> {
        return this.tasks;
    }

    // https://test-service.moony.tips/MoonyWebBackend/rest/data/getOccasions/shave/en
    getNextOccasions(taskId: string): Observable<Array<Occasion>> {
        const requestUrl = `${this.config.getRestUrl()}/${URL_TASK_OCCASIONS}/${taskId}/${this.translate.getCurrentLang()}`;
        return this.http.get<Array<Occasion>>(requestUrl);
    }
}
